import { Component, OnInit } from '@angular/core';
import { RegionesService } from '../../services/regiones.service';
import { AlertasModales } from '../../helpers/alertasModales';

@Component({
  selector: 'app-regiones',
  templateUrl: './regiones.component.html',
  styleUrls: ['./regiones.component.css']
})
export class RegionesComponent implements OnInit {
 loaded = true;
 ID_REGION = 0;
 regiones = [];
 subRegiones = [];
  constructor(private regionesService: RegionesService, private modals: AlertasModales) { }

  ngOnInit() {
    this.initRegiones();
  }

  initRegiones() {
    const subscription = this.regionesService.regiones().subscribe(regiones => {
      this.regiones = regiones;
      subscription.unsubscribe();
    });
  }

  selectRegion(ID_REGION) {
    this.ID_REGION = ID_REGION;
    const subscription = this.regionesService.subRegiones(ID_REGION).subscribe(subRegiones => {
      this.subRegiones = subRegiones;
      subscription.unsubscribe();
    });
  }

  agregarRegion(region?) {
    this.modals.AddEditRegion(region).then(res => {
      if (res) {
        let found = false;
        for (const val of this.regiones) {
          if (val.ID_REGION === res.ID_REGION) {
            val.nombre = res.nombre;
            found = true;
            break;
          }
        }

        if (!found) {
          this.regiones.push(res);
        }
      }
    });
  }

  agregarSubRegion(subRegion?) {
    this.modals.AddEditSubRegion(subRegion ? subRegion : this.ID_REGION).then(res => {
      if (res) {
        let found = false;
        for (const val of this.subRegiones) {
          if (val.ID_SUB_REGION === res.ID_SUB_REGION) {
            val.nombre = res.nombre;
            found = true;
            break;
          }
        }

        if (!found) {
          this.subRegiones.push(res);
        }
      }
    });
  }

  eliminar(data, tipo) {
    const ID = tipo === 'region' ? data.ID_REGION : data.ID_SUB_REGION;
    const msg = `Eliminar la ${tipo} <b>${ data.nombre}</b>`;
    this.modals.confirmModalJquery('¿Estas seguro?', msg, 'orange')
      .then(res => {
        if (res === 'SI') {
          const subscription = this.regionesService.removerRegionSubRegion(ID, tipo).subscribe(resp => {
            console.log(resp, this.ID_REGION);
            if (String(this.ID_REGION) === resp) {
              this.ID_REGION = 0;
              this.subRegiones = [];
            }
            if (tipo === 'region') {
              for (let i = 0; i < this.regiones.length; i++) {
                if ( String(this.regiones[i].ID_REGION) === resp) {
                  this.regiones.splice( i, 1);
                }
              }
            } else {
              for (let i = 0; i < this.subRegiones.length; i++) {
                if ( String(this.subRegiones[i].ID_SUB_REGION) === resp) {
                  this.subRegiones.splice( i, 1);
                }
              }
            }
            subscription.unsubscribe();
          }, error => {
            this.modals.validacionesModalJquery('', error.error,
            'red',
            'modern',
            false);
            subscription.unsubscribe();
          });
        }
      });
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/regiones/regiones.component.ts